import styled, { css } from "styled-components";
import tw from "twin.macro";

import { BoxSizingStyle } from "../BoxSizingStyle";
import { Dot } from "../Dot";
import { FontStyle } from "../FontStyle";

export const StyledTag = styled.div`
  ${tw`tw-flex tw-items-center`}
  font-size: 13px;
  line-height: 1.375;
  ${BoxSizingStyle}
  ${FontStyle}
`;

StyledTag.displayName = "StyledTag";

interface IStyledTagDot {
  $showText?: boolean;
}

export const StyledTagDot = styled(Dot)<IStyledTagDot>`
  ${(props) =>
    props.$showText &&
    css`
      ${tw`tw-mr-1`}
    `}
`;

StyledTagDot.displayName = "StyledTagDot";

export const StyledTagText = styled.div`
  ${tw`tw-uppercase`}
  ${(props) =>
    props.color &&
    css`
      color: ${props.color};
    `}
`;

StyledTagText.displayName = "StyledTagText";
